module.exports = __webpack_public_path__ + "img/footer-background.8eecedb4.png";